<div id="map" style="width: 100%; height: 400px"></div>
